import React from "react";
import { withRouter } from "react-router-dom";
import withFirebase from "../hoc/withFirebase";
import withUser from "../hoc/withUser";
import AddInvoicePrintData from "../components/AddInvoicePrintData";
// import { Route } from "react-router-dom";

class AddInvoicePrintDataContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deals: [],
      isLoading: true,
      currentInvoiceData: [],
      organisations: []
    };
  }
  componentWillMount() {
    this.invoicePrintData();
    this.fetchOrganisations();
  }
  invoicePrintData = () => {
    this.props.db
      .collection("invoicePrintData")
      .where("userId", "==", this.props.user.uid)
      .onSnapshot(querySnapshot => {
        const currentInvoiceData = [];
        querySnapshot.forEach(doc => {
          if (doc.exists) {
            const singleInvoicePrintData = doc.data();
            singleInvoicePrintData.id = doc.id;
            currentInvoiceData.push(singleInvoicePrintData);
          }
        });
        this.setState({ currentInvoiceData, isLoading: false });
      });
  };
  fetchOrganisations = () => {
    this.props.db
      .collection("organisations")
      .where("createdBy", "==", this.props.user.uid)
      .onSnapshot(querySnapshot => {
        const organisations = [];
        querySnapshot.forEach(doc => {
          const singleOrganisation = doc.data();
          singleOrganisation.organisationId = doc.id;
          organisations.push(singleOrganisation);
        });
        this.setState({ organisations, isLoading: false });
      });
  };
  addInvoicePrintData = (invoicePrintData, operation, invoicePrintDataId) => {
    if (operation === "add") {
      this.props.db.collection("invoicePrintData").add(invoicePrintData);
    }
    if (operation === "update") {
      this.props.db
        .collection("invoicePrintData")
        .doc(invoicePrintDataId)
        .update(invoicePrintData);
    }
  };
  render() {
    const { currentInvoiceData, organisations } = this.state;
    const { user } = this.props;
    console.log("in Invoice Print Data container");
    return (
      <div>
        {/* <Route
          path="/addInvoicePrintData/:uid"
          render={props => ( */}
        <AddInvoicePrintData
          addInvoicePrintData={this.addInvoicePrintData}
          currentInvoiceData={currentInvoiceData}
          user={user}
          organisations={organisations.find(
            org => org.createdBy === this.props.user.uid
          )}
        />
        {/* )}
        />
        <Route
          path="/deals/addInvoicePrintData/:uid"
          render={props => (
            <AddInvoicePrintData
              addInvoicePrintData={this.addInvoicePrintData}
              currentInvoiceData={currentInvoiceData}
              user={user}
              organisations={organisations.find(
                org => org.createdBy === this.props.user.uid
              )}
            />
          )}
        /> */}
      </div>
    );
  }
}

export default withRouter(withUser(withFirebase(AddInvoicePrintDataContainer)));
